export default __webpack_public_path__ + "static/media/emailWhite.6f3a664f.svg";